/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';
import { NamespacesApiService } from '../http';
import { UserService } from '../../../../core/services';

@Injectable()
export class NamespaceResolvers {
    constructor(
        private namespaceApiService: NamespacesApiService,
        private userService: UserService
    ) {
    }

    public resolve() {
        const organisationId = this.userService.getUser('organisationId');
        if (organisationId > 0) {
            return this.namespaceApiService.getAll(organisationId);
        } else {
            return;
        }
    }
}
